import { STATS } from "../../data/content";
import { Rise } from "./Reveal";

export const Stats = () => {
  return (
    <section data-testid="stats-section" className="mx-auto max-w-[1400px] px-6 lg:px-10 py-24 lg:py-32">
      <Rise className="mb-14 max-w-2xl">
        <span className="font-mono-ui text-[11px] font-bold uppercase tracking-[0.2em] text-primary">
          Why FireFlink
        </span>
        <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-none">
          Automation that outpaces your release cycle.
        </h2>
      </Rise>

      <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-border bg-border lg:grid-cols-4">
        {STATS.map((s, i) => (
          <Rise
            key={i}
            delay={i * 0.08}
            className="bg-card p-8 lg:p-10"
          >
            <div className="font-heading text-5xl lg:text-6xl font-semibold tracking-tighter text-foreground">
              {s.value}
            </div>
            <p className="mt-4 text-sm leading-relaxed text-muted-foreground">{s.label}</p>
          </Rise>
        ))}
      </div>
    </section>
  );
};
